export default __webpack_public_path__ + "static/media/delete.384038cd.svg";